import React from 'react';
import { connect } from 'react-redux';

import { NonAuthedFooter } from './NonAuthedFooter';
import { AuthedFooter } from './AuthedFooter';

const Footer = ({ auth }) => {
  const removeFooterForReset = () => {
    const path = window.location.pathname.split('/')[1];

    if (path === 'reset') {
      return true;
    }

    return false;
  }
  return <div id="footer-container">{auth ? AuthedFooter() : removeFooterForReset() ? '' : NonAuthedFooter()}</div>;
};

export default connect((state) => ({
  auth: state.auth.authenticated,
}))(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js